
export default {
  name: 'configCard',
  props: {
    title: {
      type: String,
      required: true
    },
    formConfig: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    },
    formItemList: {
      type: Array,
      required: true
    },
    formClass: {
      type: String,
      default: ''
    },
    formLoading: {
      type: Boolean,
      default: false
    },
    customButton: {
      type: Object
    },
    channelId: {
      type: Number,
      default: 0
    },
    layout: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },

  watch: {},
  methods: {
    // 父级引用
    validateField: function validateField(name) {
      this.$refs.form.validateField(name);
    },
    validate: function validate(cb) {
      return this.$refs.form.validate(cb);
    }
  },
  mounted: function mounted() {
    this.$emit('mounted');
  }
};